import { forwardRef, type Ref, type SVGProps } from "react";
const IconHourglassFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M26 26h-1c0-4.45-2-8.27-5-10 2.93-1.73 5-5.55 5-10h1a2 2 0 0 0 0-4H6a2 2 0 0 0 0 4h1c0 4.45 2 8.27 5 10-3 1.73-5 5.55-5 10H6a2 2 0 0 0 0 4h20a2 2 0 0 0 0-4M11 12h10c0 2-4.5 3-5 3s-5-1-5-3m-1 14c0-3 4.5-7 6-7s6 4 6 7Z" />
  </svg>
);
const ForwardRef = forwardRef(IconHourglassFilledSVG);
ForwardRef.displayName = "IconHourglassFilled";
export { ForwardRef as IconHourglassFilled };
